export default "__VITE_ASSET__BxGv5CRd__"